import React from "react";
import { useRelationshipInsights } from "@features/cx/consumerManagement/hooks";
import { RelationshipInsights } from "../../../RelationshipInsights";

interface DetailTabProps {
  consumer?: any;
  consumerId: string;
  consumerNo: string;
  remoteUtilityId: number;
}

export const DetailTab: React.FC<DetailTabProps> = ({
  consumer,
  consumerId,
  consumerNo,
  remoteUtilityId,
}) => {
  const { data: relationshipData } = useRelationshipInsights(
    consumerId,
    remoteUtilityId ? remoteUtilityId.toString() : "",
  );

  return (
    <div className="space-y-4 pt-2">
      {relationshipData ? (
        <RelationshipInsights
          accountAge={relationshipData.accountAgeMonths}
          serviceRequestCount={relationshipData.serviceRequestCount}
          complaintCount={relationshipData.complaintRequestCount}
          communicationPreference={relationshipData.communicationPreference}
          consumer={consumer}
        />
      ) : (
        <RelationshipInsights
          accountAge={0}
          serviceRequestCount={0}
          complaintCount={0}
          communicationPreference="Email"
          consumer={consumer}
        />
      )}
    </div>
  );
};

export default DetailTab;
